import {Image, Box, Center} from 'platform/foundation';
import styled from 'styled-components';

import i18n from '@dms/i18n';

export function CarVerticalLogo() {
  return (
    <StyledCarVerticalBackground>
      <Center width="100%" height="100%">
        <Box width="75%" height="75%">
          <Image
            alt={i18n.t('page.integrations.labels.carVerticalTitle')}
            src="../../../../assets/images/car_vertical_logo.svg"
            width="100%"
            height="100%"
            fit="contain"
          />
        </Box>
      </Center>
    </StyledCarVerticalBackground>
  );
}

// Specific color – Car Vertical logo background color
// eslint-disable-next-line eag/no-css-property
const StyledCarVerticalBackground = styled.div`
  background-color: #2f74e8;
  width: 100%;
  height: 100%;
`;
